import React from 'react';
import PropTypes from 'prop-types';

function Help({ size, ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <circle cx="12" cy="17" r="0.1" />
      <path d="M12 14.5v-1 0c0-.64.25-1.25.7-1.7l.64-.64c.1-.1.2-.22.29-.35l.1-.16c.47-.7.47-1.6 0-2.3v0a2.08 2.08 0 00-.58-.58l-.06-.05a2.25 2.25 0 00-2.26-.14v0c-.53.27-.94.74-1.12 1.3l-.07.2c-.1.28-.14.57-.14.87V10" />
    </svg>
  );
}

Help.propTypes = {
  stroke: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Help;
